import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import i18n from "../i18n";
import { langFromPath } from "../lib/locale";

// Sincronizza la lingua attiva (i18n + <html lang>) con il prefisso URL.
// Il redirect di prima visita e' gestito in index.js (full reload).
export default function LocaleManager({ children }) {
  const location = useLocation();
  const lang = langFromPath(location.pathname);

  useEffect(() => {
    i18n.changeLanguage(lang);
    if (typeof document !== "undefined") document.documentElement.lang = lang;
  }, [lang]);

  return children;
}
